import { css } from 'lit-element';
import { pxToRem } from 'lm-ui-kit/src/utils/css-utils';
import { mobile, tablet } from '../utils';

export const styles = css`
  .name-button {
    --button-color: #000000;
  }

  :host {
    display: block;
    font-size: ${pxToRem(14)};

    margin: 0 -${pxToRem(16)};
    padding: ${pxToRem(10)} ${pxToRem(16)};
    border-bottom: 1px solid #ddd;
  }

  .menu-container {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    margin-bottom: ${pxToRem(9)};
  }

  .name::slotted(*) {
    margin: 0;
    padding: 0;
    font-weight: 600;
    text-transform: uppercase;
    line-height: 1.1;
    text-align: left;
    font-size: ${pxToRem(14)};
  }

  .menu-container.hide {
    display: none;
  }

  .menu::slotted(uc-footer-menu-item) {
    margin-right: 10px;
  }

  .accordion {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: ${pxToRem(4)};
  }

  .icon-container {
    transform: rotate(270deg);
  }

  .icon-button {
    width: ${pxToRem(9)};
    height: ${pxToRem(14)};
  }

  ${mobile(css`
    .menu-container {
      // max-height: 700px;
      // transition: max-height 0.7s ease-out, margin-bottom 0.7s ease-out;
    }
    .menu-container.hide {
      // margin-bottom: 0;
      // max-height: 0;
    }
  `)}

  ${tablet(css`
    :host {
      font-size: ${pxToRem(18)};
      height: fit-content;
      padding: 0;
      border-bottom: none;
      margin: 0;
    }

    .name::slotted(*) {
      margin-bottom: ${pxToRem(18)};
      margin-top: ${pxToRem(4)};
      font-size: ${pxToRem(18)};
    }

    .icon-container {
      display: none;
    }

    .accordion {
      display: block;
      margin: 0;
    }

    .menu-container.hide {
      display: block;
    }

    .menu-container {
      column-count: 1;
    }

    .columns.menu-container {
      column-count: 2;
    }

    .menu::slotted(uc-footer-menu-item) {
      width: 100%;
      line-height: 2.17;
    }
  `)}
`;
